import { Component, Input, OnChanges, SimpleChanges, inject } from "@angular/core";
import { SyncAction } from "../../../shared/types/sync-action";
import { ApplicationState } from "../../../shared/types";
import { Store } from "@ngrx/store";
import { BehaviorSubject, of, ReplaySubject } from "rxjs";
import { switchMap } from "rxjs/operators";
import { getActionType } from "../../pipes/action-type-name.pipe";

@Component({
	selector: "ic-sync-action-item",
	templateUrl: "./sync-action-item.component.html",
	styleUrls: ["./sync-action-item.component.scss"],
	standalone: false,
})
export class SyncActionItemComponent implements OnChanges {
	private readonly store = inject<Store<ApplicationState>>(Store);

	// @ts-expect-error TS2564
	@Input() syncAction: SyncAction;

	showPath$ = new BehaviorSubject(false);

	date = "";
	residentId$ = new ReplaySubject<string>(1);
	resident$ = this.residentId$.pipe(
		switchMap((id) => {
			if (id) {
				return this.store.select((state) => state.data.patients[id]);
			}

			return of(null);
		}),
	);

	ngOnChanges(changes: SimpleChanges) {
		if (changes.syncAction) {
			if (this.syncAction) {
				if (this.syncAction.body) {
					const body =
						Array.isArray(this.syncAction.body) && this.syncAction.body.length >= 1
							? this.syncAction.body[0]
							: this.syncAction.body;

					const { date, administerDate, creationDate } = body;
					this.date = date || administerDate || creationDate || "";
				}

				if (this.syncAction.path) {
					const pathItems = this.syncAction.path.split("/");

					const actionType = getActionType(this.syncAction);

					switch (actionType) {
						case "medication-tasks": {
							this.residentId$.next(pathItems[4]);

							break;
						}
						default: {
							this.residentId$.next(pathItems[3]);
						}
					}
				}

				return;
			}

			this.date = "";
		}
	}
}
